import React from 'react';

function MessageList({ messages, total, unread, loadingMore, selectedMessage, onSelectMessage, onDeleteMessage, onRefresh, onLoadOlder }) {
    
    const truncateSubject = (subject, maxLength = 40) => {
        if (!subject || subject.length <= maxLength) return subject || '(No Subject)';
        return subject.substring(0, maxLength) + '...';
    };

    const formatSender = (from, fromName) => {
        if (fromName && fromName !== from) {
            return fromName;
        }
        return from;
    };

    if (messages.length === 0) {
        return (
            <div className="message-list">
                <div className="no-messages">
                    <p>No messages in your inbox</p>
                </div>
            </div>
        );
    }

    return (
        <div className="message-list">
            <div className="message-list-header">
                <span>
                    {total > messages.length
                        ? `${messages.length} of ${total.toLocaleString()} messages`
                        : `${messages.length} messages`}
                    {unread > 0 && ` · ${unread.toLocaleString()} unread`}
                </span>
                {onRefresh && (
                    <button onClick={onRefresh} className="btn btn-ghost btn-sm refresh-button">
                        Refresh
                    </button>
                )}
            </div>
            
            <div className="message-list-items">
                {messages.map(message => (
                    <div 
                        key={message.id}
                        className={`message-item ${selectedMessage?.id === message.id ? 'selected' : ''} ${!message.read ? 'unread' : ''}`}
                        onClick={() => onSelectMessage(message)}
                    >
                        <div className="message-item-content">
                            <div className="message-sender">
                                {formatSender(message.from, message.from_name)}
                                {!message.read && <span className="unread-indicator">●</span>}
                            </div>
                            
                            <div className="message-subject">
                                {truncateSubject(message.subject)}
                            </div>
                        </div>
                        
                        <div className="message-actions">
                            <button 
                                className="btn-delete"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteMessage(message.id);
                                }}
                                title="Delete message"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                ))}

                {onLoadOlder && total > messages.length && (
                    <div className="message-list-more">
                        <button
                            onClick={onLoadOlder}
                            disabled={loadingMore}
                            className="btn btn-ghost btn-sm"
                        >
                            {loadingMore ? 'Loading...' : 'Load older messages'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default MessageList;